import { OrganizationKeyName } from "../../../model/Organization";

export const GET_HOMEPAGE_LIST = "SHOP:GET_HOMEPAGE_LIST";

export const getHomepageListAction = (organization: OrganizationKeyName) => ({
  type: GET_HOMEPAGE_LIST as typeof GET_HOMEPAGE_LIST,
  organization,
});

export type GetHomepageListAction = ReturnType<typeof getHomepageListAction>;
